export interface QbDepositSummary {
    qboDepositId: number;
    txnDate: string;
    totalAmt: number;
    lineCount: number;
    unlabeledLineCount: number;
    depositAccount: string;
}

export interface QbDepositLine {
    lineNum: number;
    amount: number;
    labeled: boolean;
    currentEntity?: string;
    currentClass?: string;
    currentAccount?: string;
    confidence?: 'HIGH' | 'MEDIUM' | 'LOW';
    suggestedEntity?: string;
    suggestedClass?: string;
    suggestedAccount?: string;
    candidates?: QbMatchCandidate[];
}

export interface QbMatchCandidate {
    reservationId: number;
    paymentConfirmId?: number;
    confirmationNumber: string;
    guestFirstName: string;
    guestLastName: string;
    checkInDate: string;
    island: string;
    propertyCode: string;
}

export interface QbMatchResult {
    qboDepositId: number;
    txnDate: string;
    lineCount: number;
    unlabeledLineCount: number;
    totalAmt: number;
    lines: QbDepositLine[];
}

export interface QbApplyLineRequest {
    lineNum: number;
    entity: string;
    qbClass: string;
    account: number;
    reservationId?: number;
    paymentConfirmId?: number;
    confidence: 'HIGH' | 'MEDIUM' | 'LOW' | 'MANUAL';
}

export interface QbApplyRequest {
    lines: QbApplyLineRequest[];
    approvedBy: string;
    userId: number;
}

export interface QbAuditEntry {
    auditId?: number;
    qboDepositId: number;
    appliedAt: string;
    appliedBy: string;
    lineNum: number;
    entity: string;
    qbClass: string;
    account: string;
    confidence: string;
    status: string;
}
